<script>
  export let story
</script>

<style>
  .title {
    font-size: 1.1em;
  }
  .author {
    margin-top: 3px;
    font-size: 0.8em;
    color: #ffffff;
  }
  .other-metadata {
    margin-top: 3px;
    font-size: 0.8em;
    color: #ffffff;
  }
</style>

<div class="title">
  { story.title }
</div>
<div class="author">
  { story.author }
</div>
<div class="other-metadata">
  { story.theme } | { story.genre } | { story.country }
</div>
